<template>
    <div class="images-uploader">
        <div class="row mx-n2 justify-content-center justify-content-sm-start">
            <template v-for="file in list">
                <div class="col-8 col-sm-6 col-md-4 col-lg-3 mb-2 px-2 images-uploader__col">
                    <div class="card h-100 justify-content-between">
                        <div class="responsive-ratio responsive-ratio-4/3 responsive-ratio-sm-1/1">
                            <div class="responsive-ratio-item d-flex align-items-center justify-content-center">
                                <img class="img-fluid mh-100" :src="file.thumbnail" :alt="file.legend">
                            </div>
                        </div>
                        <template v-if="file.legend || file.copyright">
                            <div class="card-body flex-grow-0 p-2">
                                <template v-if="file.legend">
                                    <div class="mt-2 small">{{ file.legend }}</div>
                                </template>
                                <template v-if="file.copyright">
                                    <div class="mt-2 small">© {{ file.copyright }}</div>
                                </template>
                            </div>
                        </template>
                    </div>
                </div>
            </template>
        </div>

        <button type="button" class="btn btn-outline-primary" @click="handleEditClicked">Modifier...</button>

        <b-modal
            data-legacy
            :visible="editVisible"
            title="Modification des visuels"
            size="lg"
            hide-footer
            hide-header-close
            no-close-on-esc
            no-close-on-backdrop
            @hidden="handleModalClosed"
        >
            <template v-if="editVisible">
                <UploadsEditor
                    :files="list"
                    :url="uploadUrl"
                    :accept="accept"
                    :max-size="maxSize"
                    :csrf-token="csrfToken"
                    :limit="limit"
                    :errors="errors"
                    :loading="editLoading"
                    :name="name"
                    @submit="handleUploadSubmitted"
                    @cancel="handleUploadCancelled"
                />
            </template>
        </b-modal>
    </div>
</template>

<script>
    import UploadsEditor from './UploadsEditor.vue';
    import axios from 'axios';
    import { errorAlert } from "../../util/alert";

    export default {
        components: {
            UploadsEditor,
        },
        props: {
            files: Array,
            endpoint: String,
            uploadUrl: String,
            accept: {
                type: String,
                default: '.jpg,.jpeg,.png,.gif',
            },
            maxSize: {
                type: Number,
                default: 6,
            },
            limit: Number,
            csrfToken: {
                type: String,
                required: true,
            },
            name: {
                type: String,
                default: 'visuals',
            }
        },
        data() {
            return {
                list: this.files ?? [],
                editVisible: false,
                editLoading: false,
                errors: null,
            }
        },
        methods:{
            handleModalClosed() {
                this.editVisible = false;
            },
            handleUploadCancelled() {
                this.editVisible = false;
            },
            handleUploadSubmitted(files) {
                this.errors = null;
                this.editLoading = true;
                const name = this.name;
                axios.post(this.endpoint, {
                    [name]: files
                }).then(response => {
                    this.list = response.data.data;
                    this.editVisible = false;
                    this.$emit('change', [...this.list]);
                }).catch(error => {
                    const data = error.response.data;
                    if(error.response.status === 422) {
                        this.errors = data.errors;
                        const name = this.name;
                        const message = data.errors[name]
                            ? data.errors[name][0]
                            : 'Le formulaire contient des erreurs, veuillez les corriger pour continuer';
                        errorAlert(this, message);
                    }
                }).finally(() => {
                    this.editLoading = false;
                });
            },
            handleEditClicked() {
                this.editVisible = true;
            },
        }
    }
</script>
